module.exports = __webpack_public_path__ + "static/media/frelancer-pictures.e3fede1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/FreelancerChooserPopup/frelancer-pictures.svg
// module id = 2215
// module chunks = 0